module.exports = __webpack_public_path__ + "media/images/hamburger_icon-c3a60e81.svg";